import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { OnresizeService } from 'src/app/services/onresize.service';

@Component({
  selector: 'app-isomasters-scrollbar',
  templateUrl: './isomasters-scrollbar.component.html',
  styleUrls: ['./isomasters-scrollbar.component.scss'],
})
export class IsomastersScrollbarComponent implements OnInit, AfterViewInit {
  @Input() public scrolled: EventEmitter<any>;
  @Input() elementIHaveToscroll: Element;
  @ViewChild('thumb') thumb: ElementRef;

  scrollOffset: number;
  dragEnabled: boolean;
  relativeX: number;

  constructor(
    private onresizeService: OnresizeService,
    private host: ElementRef
  ) {}

  ngOnInit() {
    this.scrolled.pipe(debounceTime(10)).subscribe(() => {
      this.scrollOffset = this.getThumbOffset();
    });

    this.onresizeService.windowResized$.subscribe(() => {
      this.scrollOffset = this.getThumbOffset();
    });
  }

  ngAfterViewInit() {
    this.relativeX = (this.thumb.nativeElement as Element).getBoundingClientRect().left;
  }

  calculateRelativeScrollPosition(): number {
    return (
      this.elementIHaveToscroll.clientWidth /
      (this.elementIHaveToscroll.scrollWidth - this.elementIHaveToscroll.clientWidth)
    );
  }

  getThumbOffset(): number {
    return Math.min(
      Math.max(
        0,
        Math.ceil(
          (this.elementIHaveToscroll.scrollLeft - this.thumb.nativeElement.clientWidth / 2) *
            this.calculateRelativeScrollPosition()
        )
      ),
      this.host.nativeElement.clientWidth - this.thumb.nativeElement.clientWidth / 2
    );
  }

  positionClicked(event: MouseEvent) {
    this.elementIHaveToscroll.scrollTo({
      left: event.offsetX / this.calculateRelativeScrollPosition(),
      top: this.elementIHaveToscroll.scrollTop,
      behavior: 'smooth',
    });
  }

  mouseDown() {
    this.dragEnabled = true;
  }

  mouseLeave(event: MouseEvent) {
    this.mouseUp(event);
  }

  mouseMove(event: MouseEvent) {
    if (this.dragEnabled) {
      this.setViewPosition(event);
    }
  }

  setViewPosition(event: MouseEvent) {
    this.elementIHaveToscroll.scrollTo({
      left: (event.clientX - this.relativeX) / this.calculateRelativeScrollPosition(),
      top: this.elementIHaveToscroll.scrollTop,
      behavior: 'auto',
    });
  }

  mouseUp(event: MouseEvent) {
    if (this.dragEnabled) {
      this.dragEnabled = false;

      setTimeout(() => {
        this.setViewPosition(event);
      });
    }
  }

  scrolling(event: WheelEvent) {
    if (event.shiftKey) {
      this.elementIHaveToscroll.scrollTo({
        left: this.elementIHaveToscroll.scrollLeft + event.deltaY,
        top: this.elementIHaveToscroll.scrollTop,
        behavior: 'smooth',
      });
    }
  }
}
